import { render, staticRenderFns } from "./HabilitarCompraDistribuidaPorFilial.vue?vue&type=template&id=20872bec&scoped=true"
import script from "./HabilitarCompraDistribuidaPorFilial.vue?vue&type=script&lang=js"
export * from "./HabilitarCompraDistribuidaPorFilial.vue?vue&type=script&lang=js"
import style0 from "./HabilitarCompraDistribuidaPorFilial.vue?vue&type=style&index=0&id=20872bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20872bec",
  null
  
)

export default component.exports